export default __webpack_public_path__ + "808f4dab18401c8cfc99f1a4b39c47f8.svg";